import { Box, HStack, Icon, Text } from '@chakra-ui/react'
import { ExternalLink } from 'lucide-react'
import { Link } from 'react-router-dom'

import { ImageContainer } from '@/components/shared/displayers/ImageContainer'
import { useAuthStore } from '@/features/sessao/store/useAuthStore'
import { Asset, Equipment } from '@/services/backend/config/entities'

type Props = {
  data: Asset & { Equipment?: Equipment }
}

export const Asset_Displayer = ({ data }: Props) => {
  const { user } = useAuthStore()

  return (
    <HStack>
      <ImageContainer src={data.Equipment?.imageStr ?? undefined} size="xs" />
      <Box>
        <Text fontSize="xl">
          <Text as="span" fontSize="xs" color="gray.400" mr={2}>
            Patrimônio
          </Text>
          {data.assetNumber}
          {user && (
            <Link to={`/app/entity/patrimonios/${data.id}/detalhes`}>
              <Icon as={ExternalLink} color="primary.500" boxSize={3} ml={2} />
            </Link>
          )}
        </Text>
        <Text color="gray.400" fontSize="sm">
          {data.Equipment?.name ?? data.name}
        </Text>
      </Box>
    </HStack>
  )
}
